// extracted by mini-css-extract-plugin
export default {"container":"TeamsLive_container__r0fIQ","odds":"TeamsLive_odds__mCLQ9"};